import { isExecutive, isOrganizationAdmin, isReportingManager, type Role } from "@packages/core/session/roles.ts";

export const ORGANIZATION_ENGAGEMENT_ACCESS: readonly Role[] = [isReportingManager, isExecutive];

export const ORGANIZATION_FEEDBACK_INBOX_ACCESS: readonly Role[] = [isExecutive];

export const ORGANIZATION_FULL_PROFILE_ACCESS: readonly Role[] = [isExecutive, isOrganizationAdmin];

export const ORGANIZATION_PLANS_ACCESS: readonly Role[] = [isExecutive];

export const ORGANIZATION_ONBOARDING_ACCESS: readonly Role[] = [isOrganizationAdmin];
